import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const ContractReducer = createSlice({
  name: "Contract",
  initialState,
  reducers: {
    defaultAction: (state, { payload }) => {
      console.log("ContractReducer state and payload", state, payload);
    },
  },
});

const { reducer, actions } = ContractReducer;
export const { defaultAction } = actions;
export default reducer;
